import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex flex-no-wrap justify-start fill-height pa-2 align-center" }
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass({
          'd-flex': true,
          'flex-column': true,
          'ml-2': true,
          'flex-grow-1': true,
          'fill-height': true,
          'justify-center': true,
        })
}
const _hoisted_3 = { class: "text-subtitle-2 font-weight-bold text-center" }
const _hoisted_4 = { class: "event-status" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("en cours")

import { onBeforeUnmount, ref } from "vue";
import type { Event } from "@emblem/api";

import VCountdown from "./VCountdown.vue";

import emblemGrenoble from "@/assets/grenobleImage";

import MarkdownViewer from "./MarkdownViewer.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EventCard',
  props: {
    event: null
  },
  setup(__props: any) {



const now = ref(new Date());

const interval = setInterval(() => (now.value = new Date()));
onBeforeUnmount(() => clearInterval(interval));

function formatDate(date: Date) {
  return [
    date.getDate().toString().padStart(2, "0"),
    (date.getMonth() + 1).toString().padStart(2, "0"),
    date.getFullYear() % 2000,
  ].join("/");
}

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_img, {
          "lazy-src": _unref(emblemGrenoble),
          src: __props.event.thumbnail,
          "min-width": "100",
          "max-width": "100"
        }, null, 8, ["lazy-src", "src"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.event.title.toUpperCase()), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (now.value < __props.event.start)
            ? (_openBlock(), _createBlock(VCountdown, {
                key: 0,
                size: "small",
                date: __props.event.start
              }, null, 8, ["date"]))
            : (now.value < __props.event.end)
              ? (_openBlock(), _createBlock(_component_v_chip, {
                  key: 1,
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_chip, {
                  key: 2,
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("fini le " + _toDisplayString(formatDate(__props.event.end)), 1)
                  ]),
                  _: 1
                }))
        ]),
        _createVNode(_component_v_dialog, { activator: "parent" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              width: "400px",
              "max-width": "80vw",
              "max-height": "80vh"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(MarkdownViewer, {
                      content: __props.event.content
                    }, null, 8, ["content"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})